import React from "react";
import { useLocation } from "react-router-dom";
import logo from "../../assets/booklocal-logo.gif";
import "./NavBar.css";
import { FaHome, FaInfoCircle, FaUsers, FaStethoscope } from 'react-icons/fa';

const NavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const shouldShowRegisterButton = location.pathname !== "/register-pharmacy";

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <a href="/" className="navbar-logo">
          <img src={logo} alt="Book Local" />
        </a>

        <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
          <div></div><div></div><div></div>
        </div>

        <div className={`navbar-links ${isMobileMenuOpen ? "active" : ""}`}>
          <a href="/"><FaHome /> Home</a>
          <a href="https://www.booklocal.co.in/about-us"><FaInfoCircle /> About Us</a>
          <a href="https://www.booklocal.co.in/for-users"><FaUsers /> For Users</a>
          <a href="https://www.booklocal.co.in/for-doctors"><FaStethoscope /> For Doctors</a>
          {shouldShowRegisterButton && (
            <a href="/register-pharmacy" className="register-button mobile-register-button">
              Register your Pharmacy
            </a>
          )}
        </div>

        {shouldShowRegisterButton && (
          <a href="/register-pharmacy" className="register-button desktop-register-button">
            Register your Pharmacy
          </a>
        )}
      </div>
    </nav>
  );
};

export default NavBar;